<div class="bg"></div>

<h1 class="py-5 text-center">Ratkaise</h1>
<p class="py-5 text-center">Lorem Ipsum</p>
<p class="py-5 text-center">Ipsum Lorem</p>

